import React, { useEffect, useState } from "react";
import { apiGet } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import { isEmpty } from "lodash";
import Layout from "./Layout";
import PromotionDetail from "../component/PromotionDetail";
import referencePromotions from "./referencePromotions.json";

const PromotionWeb = () => {
  const [data, setData] = useState([]);
  const [active, setActive] = useState("");
  const lang = useContextSelector(AuthContext, ctx => ctx.lang);
  const profileData = useContextSelector(AuthContext, (ctx) => {
    return ctx.profileData;
  });
  const setRegisterModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.setRegisterModal;
  });
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const getFilteredOfferList = (count, list) => {
    const depositKeysToRemove = [
      "OnFirstDeposit",
      "OnSecondDeposit",
      "OnThirdDeposit",
      "OneFourthDeposit",
    ];

    const keysToRemove = depositKeysToRemove.slice(0, count);
    return list.filter((offer) => !keysToRemove.includes(offer.offerOn));
  };

  const getData = async () => {
    const { status, data } = await apiGet(apiPath.getPromotional);
    if (status == 200) {
      if (data?.success) {
        let updated = getFilteredOfferList(
          profileData?.userDepositCount,
          data?.results?.offerList
        );
        setData(updated);
      }
    }
  };

  useEffect(() => {
    getData();
  }, [profileData]);
  const accountModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.accountModal;
  });
  const setAccountModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.setAccountModal;
  });
  return (
    <Layout>
      <div className="br_promotion_main br_main reference-promotion-page">
        <nav className="reference-promotion-tabs" aria-label="Promotion categories"><button type="button" aria-current="page">All</button></nav>
        <div className="content">
          <div className="ref-offer-grid ref-promotion-fallback">
            {referencePromotions.map((card) => (
              <button type="button" key={card.id} aria-label={`View ${card.title}`} onClick={() => setActive(card)}>
                <img src={card.src} alt={card.title} />
                <span className="reference-promotion-card-footer"><strong>{lang === "en" ? card.title : card.titleBn || card.title}</strong><span>Click to view</span></span>
              </button>
            ))}
          </div>
          {data.length > 0 && <details className="reference-supported-offers"><summary>Available chorki offers</summary>
          <ul className="prom_list">
            {" "}
            {data?.length > 0
              ? data?.map((res) => {
                  return (
                    <li
                      onClick={() =>
                        setActive(active?._id == res?._id ? "" : res)
                      }
                      className="promo-item"
                    >
                      <img
                        src={`${process.env.REACT_APP_API_BASE_URL}${res?.offerImage}`}
                        alt={res?.title}
                      />{" "}
                      <div className="promo-title">
                        <p>{res?.title}</p>{" "}
                        {res?.category == "Deposit" && (
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              if (isEmpty(user)) {
                                setRegisterModal(true);
                              } else {
                                setAccountModal({
                                  type: "deposit",
                                  status: true,
                                });
                              }
                            }}
                            style={{
                              background:
                                "linear-gradient(180deg,#174593,#0f3157)",
                              color: "white",
                              fontSize: "13px",
                              padding: "0 5px",
                              fontWeight: "600",
                              textAlign: "center",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {isEmpty(user) ? "Register" : "Deposit"}
                          </div>
                        )}
                        <div className="title-down-arrow">
                          <svg
                            data-v-08fe0fb5
                            aria-hidden="true"
                            className="svg-icon"
                          >
                            <use
                              data-v-08fe0fb5
                              xlinkHref="#icon-promo-arrow-down"
                            />
                          </svg>
                        </div>
                      </div>{" "}
                      {/**/}
                    </li>
                  );
                })
              : ""}
          </ul></details>}
          {!isEmpty(active) && (
            <PromotionDetail active={active} setActive={setActive} />
          )}
        </div>
      </div>
    </Layout>
  );
};

export default PromotionWeb;
